module.exports = __webpack_public_path__ + "static/img/图形01.8b42f38.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/图形01.png
// module id = ag7d
// module chunks = 24